<template>
  <b-row>
    <b-col md="3">
      <b-row>
        <b-col v-for="(info_card, index) in info_cards" :key="index" cols="12">
          <apartment-info-card
            v-if="
              info_card.permissions.some((el) =>
                GET_USER_PERMISSIONS.includes(el)
              )
            "
            :info="info_card"
            :variant="info_card.variant"
            @editClick="
              $router.push({
                name: info_card.route,
                params: { id: $route.params.id },
              })
            "
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col md="9">
      <b-card no-body>
        <b-card-header class="pb-0">
          <div>
            <h4 class="mx-auto mb-0 text-center">
              {{ $t("objects.house_information") }}
            </h4>
          </div>
          <div v-if="GET_USER_PERMISSIONS.includes('content_management')">
            <b-button
              v-b-modal.validated-form-modal
              variant="warning"
              size="sm"
            >
              <feather-icon icon="EditIcon" />
              {{ $t("generals.edit") }}
            </b-button>
            <b-button
              class="ml-1"
              size="sm"
              variant="danger"
              @click="deactivateApartment"
            >
              <feather-icon icon="TrashIcon" />
              {{ $t("objects.delete_home") }}
            </b-button>
          </div>
        </b-card-header>
        <hr />
        <b-card-body class="pt-0">
          <b-row class="match-height">
            <b-col md="5">
              <b-card v-if="GET_ONE_APARTMENT.image" no-body class="mt-2">
                <b-img
                  :src="GET_ONE_APARTMENT.image.url"
                  fluid
                  alt="Responsive image"
                />
                <div
                  v-if="GET_USER_PERMISSIONS.includes('content_management')"
                  class="d-flex justify-content-around mt-1"
                >
                  <b-button size="sm" variant="warning" @click="updateImage">
                    <feather-icon icon="EditIcon" /> {{ $t("generals.update") }}
                  </b-button>
                  <b-button id="delete-img-button" size="sm" variant="danger">
                    <feather-icon icon="TrashIcon" />
                    {{ $t("generals.delete") }}
                  </b-button>
                  <b-popover
                    target="delete-img-button"
                    triggers="focus"
                    placement="top"
                    variant="danger"
                    :title="$t('objects.delete_img')"
                    :show.sync="delete_img_popover"
                  >
                    <div class="d-flex justify-content-around">
                      <b-button size="sm" variant="danger" @click="deleteImage">
                        {{ $t("generals.ok") }}
                      </b-button>
                      <b-button size="sm" @click="delete_img_popover = false">
                        {{ $t("generals.no") }}
                      </b-button>
                    </div>
                  </b-popover>
                </div>
              </b-card>
              <b-button v-else size="sm" variant="warning" @click="updateImage">
                <feather-icon icon="UploadIcon" />
                {{ $t("objects.upload_img") }}
              </b-button>
              <b-form-file
                ref="imageFileInput"
                v-model="new_image_file"
                plain
                class="d-none"
                accept="image/*"
                :browse-text="$t('objects.select_floor_plans')"
                @input="fileChanged"
              />
            </b-col>
            <b-col md="7">
              <b-card class="mb-0" no-body>
                <b-card-body>
                  <description-list
                    module_prefix="apartments"
                    :desc_list="GET_APARTMENT_MAIN_INFO"
                  />
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-row>
        <b-col :md="GET_ONE_APARTMENT.file ? 8 : 12">
          <b-card :title="$t('objects.add_badge_to_home')">
            <b-card-body class="d-flex align-items-center">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="GET_ONE_APARTMENT.badge"
                  :options="GET_BADGES"
                  :aria-describedby="ariaDescribedby"
                  :text-field="`title.${$i18n.locale}`"
                  value-field="id"
                  switches
                  :disabled="
                    !GET_USER_PERMISSIONS.includes('content_management')
                  "
                  @change="changeBadges"
                />
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col v-if="GET_ONE_APARTMENT.file" md="4">
          <b-card :title="$t('objects.cadastral_documents')">
            <div class="border rounded p-1">
              <div
                class="d-flex border-bottom pb-1 justify-content-between align-items-center"
              >
                <span class="text-truncate w-50">
                  <a :href="GET_ONE_APARTMENT.file" download>
                    {{ GET_ONE_APARTMENT.file.split("/").reverse()[0] }}
                  </a>
                </span>
                <div>
                  <b-button
                    size="sm"
                    variant="info"
                    class="px-50 mr-50"
                    @click.stop="showParentFileDoc(GET_ONE_APARTMENT.file)"
                  >
                    <feather-icon icon="EyeIcon" />
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    class="px-50 mr-50"
                    @click="$_downloadBlob(GET_ONE_APARTMENT.file, 'kadastr')"
                  >
                    <feather-icon icon="DownloadIcon" />
                  </b-button>
                  <b-button
                    v-if="GET_USER_PERMISSIONS.includes('content_management')"
                    size="sm"
                    variant="danger"
                    class="px-50"
                    @click="deleteFile"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <edit-apartment-modal
      is-edit
      :def-obj="GET_ONE_APARTMENT"
      @save="refresh"
    />
    <show-file-modal :is-show-modal.sync="isShowFileModal" :url="url" />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BCardBody,
  BCardHeader,
  BCard,
  BImg,
  // BBadge,
  // BFormCheckbox,
  BFormFile,
  BPopover,
  BFormGroup,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import descriptionList from "@/components/descriptionList.vue";
import apartmentInfoCard from "@/views/modules/MyObjects/Apartments/components/apartmentInfoCard.vue";
import editApartmentModal from "@/views/modules/MyObjects/components/modals/addOrEditApartmentModal.vue";
import download from "@/mixins/download";
import showFileModal from "@/components/ShowFileModal.vue";

export default {
  components: {
    apartmentInfoCard,
    showFileModal,
    BCol,
    BRow,
    BButton,
    FeatherIcon,
    BCardBody,
    BCardHeader,
    BCard,
    BImg,
    descriptionList,
    // BBadge,
    // BFormCheckbox,
    editApartmentModal,
    BFormGroup,
    BFormFile,
    BPopover,
    BFormCheckboxGroup,
  },
  mixins: [download],
  data() {
    return {
      delete_img_popover: false,
      new_image_file: null,
      isShowFileModal: false,
      url: "",
      info_cards: [
        {
          title: "objects.view_mash",
          percent: 100,
          file_upload: false,
          icon: "TrelloIcon",
          route: "apartment-block-view",
          variant: "lighten-3 bg-primary",
          permissions: [
            "sales_management",
            "content_management",
            "supervisor",
            "manager",
            "super_manager",
          ],
        },
        {
          title: "objects.creating_mash",
          percent: 100,
          file_upload: false,
          icon: "GridIcon",
          route: "apartment-detail-layout",
          variant: "info",
          permissions: ["content_management", "super_manager"],
        },
        {
          title: "objects.layout_of_premises",
          percent: 100,
          file_upload: false,
          icon: "BoxIcon",
          route: "apartment-plannings-view",
          variant: "warning",
          permissions: ["content_management", "manager", "super_manager"],
        },
        {
          title: "objects.floor_layouts",
          percent: 100,
          file_upload: false,
          icon: "LayersIcon",
          route: "apartment-stage-plannings",
          variant: "danger",
          permissions: ["content_management", "manager", "super_manager"],
        },
      ],
      desc_list: {
        title: "G4",
        rc: "Solaris",
        default_type_of_room: this.$t("objects.apartment"),
      },
    };
  },
  computed: {
    ...mapGetters("apartments", [
      "GET_ONE_APARTMENT",
      "GET_APARTMENT_MAIN_INFO",
      "GET_BADGES",
    ]),
    ...mapGetters("users", ["GET_USER_PERMISSIONS"]),
  },
  created() {
    this.refresh();
    this.FETCH_BADGES();
  },
  methods: {
    ...mapActions("apartments", [
      "FETCH_ONE_APARTMENT",
      "EDIT_APARTMENT",
      "FETCH_BADGES",
    ]),
    ...mapMutations("breadcrumb", ["UPDATE_BREADCRUMB"]),
    updateBreadcrumb() {
      const [first, second, third] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb
      );
      second.text = this.GET_APARTMENT_MAIN_INFO.rc_object;
      third.text = this.GET_APARTMENT_MAIN_INFO.title;
      second.to = second.to.replace(":id", this.GET_ONE_APARTMENT.rc_object);
      this.UPDATE_BREADCRUMB([first, second, third]);
    },
    async refresh() {
      this.delete_img_popover = false;
      await this.FETCH_ONE_APARTMENT(this.$route.params.id).then(() => {
        this.updateBreadcrumb();
      });
    },
    deactivateApartment() {
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.EDIT_APARTMENT({ id: this.$route.params.id, is_active: false })
            .then(() => {
              this.$_successToast(this.$t("generals.deleted"));
              // this.$router.push(this.$route.breadcrumb[1].to)
              this.$router.push({
                name: "object-view",
                params: { id: this.GET_ONE_APARTMENT.rc_object },
              });
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    updateImage() {
      this.$refs.imageFileInput.$el.click();
    },
    deleteImage() {
      this.EDIT_APARTMENT({
        image: null,
        id: this.GET_ONE_APARTMENT.id,
      }).then(() => this.refresh());
    },
    changeBadges() {
      this.EDIT_APARTMENT({
        id: this.$route.params.id,
        badge: this.GET_ONE_APARTMENT.badge,
      }).then(this.refresh());
    },
    fileChanged() {
      if (this.new_image_file) {
        const fd = new FormData();
        // fd.append('author', useJwt.getUserData().id)
        fd.append("image", this.new_image_file);
        // fd.append('content_type', this.content_type_id)
        fd.append("id", this.$route.params.id);
        this.EDIT_APARTMENT(fd)
          .then(() => {
            this.refresh();
            this.new_image_file = null;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    showParentFileDoc(url) {
      this.url = url;
      this.isShowFileModal = true;
    },
    deleteFile() {
      const reqData = {
        file: null,
        id: this.$route.params.id,
      };
      this.EDIT_APARTMENT(reqData)
        .then(() => {
          this.$_successToast(this.$t("generals.changed"));
          this.refresh();
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
  },
};
</script>

<style></style>
